export default __webpack_public_path__ + "static/media/work_and_learn_image.875026f3.jpg";